<template>
  <div class="postList">
    <div class="postList_scroll" :style="{height: tableHeight}">
      <div class="accordion">
        <ul class="postList_ul">
          <li class="postList_li">
            <div class="postList_div width_fit">
              <p class="accordion__toggle_parent">
                <span class="click show_all" @click="setActive">{{ showAll }}</span>
              </p>
            </div>
          </li>

          <li
            class="postList_li"
            v-for="loginUser in dispItems"
            :key="loginUser.postId"
          >
            <div v-for="item in loginUser.loginUserPost" :key="item.postId">
              <div class="postList_div">
                <p class="accordion__toggle_parent">
                  <span
                    v-show="
                      item.childPost != null && isOpen.indexOf(item.postId) >= 0
                    "
                    @click="handleToggle(item.postId)"
                  >
                    <img
                      class="postList_nav_icon"
                      :src="openIcon"
                    />
                  </span>
                  <span
                    v-show="
                      item.childPost != null && isOpen.indexOf(item.postId) < 0
                    "
                    @click="handleToggle(item.postId)"
                  >
                    <img
                      class="postList_nav_icon"
                      :src="closeIcon"
                    />
                  </span>
                  <span v-show="item.childPost == null">
                    <img class="postList_nav_icon" :src="blackCircleIcon" />
                  </span>
                  <span
                    class="click"
                    :id="item.postId"
                    @click="setActive"
                    v-text="item.postName"
                  />
                </p>
              </div>
              <ul
                class="postListChild_ul"
                v-show="isOpen.indexOf(item.postId) >= 0"
              >
                <li
                  class="postList_li"
                  v-for="childDispLoginuser in item.childPost"
                  :key="childDispLoginuser.postId"
                >
                  <div class="postList_div">
                    <p class="accordion__toggle">
                      <span
                        v-show="
                          childDispLoginuser.grandchildPost != null &&
                          isOpen.indexOf(childDispLoginuser.postId) >= 0
                        "
                        @click="handleToggle(childDispLoginuser.postId)"
                      >
                        <img
                          class="postList_nav_icon"
                          :src="openIcon"
                        />
                      </span>
                      <span
                        v-show="
                          childDispLoginuser.grandchildPost != null &&
                          isOpen.indexOf(childDispLoginuser.postId) < 0
                        "
                        @click="handleToggle(childDispLoginuser.postId)"
                      >
                        <img
                          class="postList_nav_icon"
                          :src="closeIcon"
                        />
                      </span>
                      <span v-show="childDispLoginuser.grandchildPost == null">
                        <img class="postList_nav_icon" :src="blackCircleIcon" />
                      </span>
                      <span
                        class="click"
                        :id="childDispLoginuser.postId"
                        @click="setActive"
                        v-text="childDispLoginuser.postName"
                      />
                    </p>
                  </div>
                  <ul
                    class="postListChild_ul"
                    v-show="isOpen.indexOf(childDispLoginuser.postId) >= 0"
                  >
                    <li
                      class="postList_li"
                      v-for="grandchildDispLoginuser in childDispLoginuser.grandchildPost"
                      :key="grandchildDispLoginuser.postId"
                    >
                      <div class="postList_div">
                        <img
                          class="postList_nav_icon_grandchild"
                          :src="blackCircleIcon"
                        />
                        <p class="accordion__toggle_grandchild">
                          <span
                            class="click"
                            :id="grandchildDispLoginuser.postId"
                            @click="setActive"
                            v-text="grandchildDispLoginuser.postName"
                          />
                        </p>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <completeModalWindow :question="falseWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      showAll: '全件表示',
      isOpen: [],
      windowHeight: '',
      openIcon: require('../../img/arrowOpen.png'),
      closeIcon: require('../../img/arrowClose.png'),
      blackCircleIcon: require('../../img/blackCircle.png'),
      inputValue: '',
      showloadingModal: false,
      showFalseModal: false,
      falseWord: ''
    }
  },
  computed: {
    tableHeight() {
      const otherHeight = 110
      return this.windowHeight - otherHeight + 'px'
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showFalseModal = false
    },
    // メニューを開閉する
    handleToggle(index) {
      if (this.isOpen.indexOf(index) >= 0) {
        this.isOpen = this.isOpen.filter((n) => n !== index)
      } else {
        this.isOpen.push(index)
      }
    },
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    async setActive(e) {
      e.stopPropagation()
      var span = document.querySelectorAll('span')
      for (var i = 0; i < span.length; i++) {
        span[i].classList.remove('span_active')
      }
      e.currentTarget.classList.add('span_active')
      // 所属絞り込み処理
      this.inputValue = e.currentTarget.id
      this.$store.dispatch('loginUsers/clearChangeThumbnailPhotographList')
      this.$emit('clearFileDownloadUserIDList')

      this.$emit('change-post', this.inputValue)
    },
    clearIsOpen(e) {
      this.isOpen = []
    }
  }
}
</script>

<style scoped>
.click {
  width: 170px;
}
.postList {
  width: 220px;
  height: 86%;
  float: left;
}
.postList_scroll {
  overflow-y: scroll;
  border-right: 1px solid #808080;
}
.postList_ul {
  margin: 0;
  padding: 0;
}
.postList_li::marker {
  font-size: 0px;
}
.accordion {
  color: #444;
  top: 67px;
  left: 0;
}
.accordion__toggle {
  line-height: 2.818;
  text-align: left;
  display: block;
  width: 100%;
  position: relative;
  cursor: default;
  margin: 0;
  display: inline-flex;
}
.accordion__toggle_parent {
  line-height: 2.818;
  text-align: left;
  display: block;
  width: 100%;
  position: relative;
  cursor: default;
  margin: 0;
  display: inline-flex;
  background-color: #dbf5f1;
  border-bottom: 1px solid #bcedd5;
  border-top: 1px solid #bcedd5;
}
.span_active {
  width: 170px;
  display: inline-flex;
  background-color: #bcedd5;
}
.width_fit {
  width: 100% !important;
}
.show_all {
  padding-left: 10px;
  width: 100%;
}
.postList_div {
  vertical-align: middle;
}
.postList_nav_icon {
  height: 12px;
  width: 14px;
  vertical-align: revert;
  padding-right: 5px;
  padding-left: 7px;
  margin-top: 10px;
}
.postListChild_ul {
  margin: 0;
  padding: 5px;
}
.postList_nav_icon_grandchild {
  height: 12px;
  width: 14px;
  vertical-align: revert;
  padding-right: 5px;
  padding-left: 7px;
  margin-top: 10px;
}
.accordion__toggle_grandchild {
  line-height: 2.818;
  text-align: left;
  display: block;
  width: 80%;
  position: relative;
  cursor: default;
  margin: 0;
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/loginUsers/loginUserPostList.vue